module.exports = __webpack_public_path__ + "img/appleStoreBg.285714f7.png";